"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseMarketingMerchFromConfigsSelector = exports.defaultItemConfigSelector = exports.getBundleItemConfigsSelector = exports.getCreateSuiteItemConfigsSelector = exports.getCreateCheckoutItemConfigWithMandatoryMerchSelector = exports.getCreateItemConfigWithMandatoryMerchSelector = exports.getCreateAdditionalUnitsItemConfigSelector = exports.getCreateCheckoutOnboardingItemConfigSelector = exports.termIdFromTermSelector = exports.defaultTermIdSelector = exports.getAvailableTermsForMerchSelector = exports.availableTermsForMerchSelector = exports.onboardingMerchItemConfigSelector = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _Terms = require("self-service-api/constants/Terms");

var _RequiredOnboardingSelectors = require("pricing-pages-unified-ui/selectors/RequiredOnboardingSelectors");

var _ContactsSelectors = require("pricing-pages-unified-ui/selectors/ContactsSelectors");

var _MerchandiseSelectors = require("./MerchandiseSelectors");

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _PricingSelectors = require("./PricingSelectors");

var _itemConfigUtils = require("../utils/itemConfigUtils");

var _MarketingContactsSelectors = require("./MarketingContactsSelectors");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _MerchandiseSelectors2 = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _itemConfigUtils2 = require("self-service-api/core/utilities/itemConfigUtils");

var _ProductBasedOffersSelectors = require("pricing-pages-unified-ui/selectors/ProductBasedOffersSelectors");

var onboardingMerchItemConfigSelector = function onboardingMerchItemConfigSelector(state, merchId) {
  var requiredOnboardingMerchId = (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchId);

  if (requiredOnboardingMerchId) {
    var onboardingItemConfig = (0, _itemConfigUtils2.createItemConfigObject)({
      merchandiseId: requiredOnboardingMerchId
    });
    return onboardingItemConfig;
  }

  return null;
};

exports.onboardingMerchItemConfigSelector = onboardingMerchItemConfigSelector;

var availableTermsForMerchSelector = function availableTermsForMerchSelector(state, merchId) {
  var getEligibleTermIds = (0, _PricingSelectors.getEligibleTermIdsSelector)(state);
  return getEligibleTermIds(merchId);
};

exports.availableTermsForMerchSelector = availableTermsForMerchSelector;

var getAvailableTermsForMerchSelector = function getAvailableTermsForMerchSelector(state) {
  return function (merchId) {
    return (0, _PricingSelectors.getEligibleTermIdsSelector)(state)(merchId);
  };
};

exports.getAvailableTermsForMerchSelector = getAvailableTermsForMerchSelector;

var defaultTermIdSelector = function defaultTermIdSelector(state, merchId) {
  var eligibleTermIds = availableTermsForMerchSelector(state, merchId);
  var defaultTerm = (0, _itemConfigUtils.getApplicableTerm)(_Terms.MONTHLY, eligibleTermIds);
  return eligibleTermIds[defaultTerm];
};

exports.defaultTermIdSelector = defaultTermIdSelector;

var termIdFromTermSelector = function termIdFromTermSelector(state, term, merchId) {
  var eligibleTermIds = availableTermsForMerchSelector(state, merchId);
  var termToApply = (0, _itemConfigUtils.getApplicableTerm)(term, eligibleTermIds);
  return eligibleTermIds[termToApply];
};

exports.termIdFromTermSelector = termIdFromTermSelector;

var getCreateCheckoutOnboardingItemConfigSelector = function getCreateCheckoutOnboardingItemConfigSelector(state) {
  return function (merchId) {
    var requiredOnboardingMerchId = (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchId);
    if (!requiredOnboardingMerchId) return [];
    var productBasedOfferId = (0, _ProductBasedOffersSelectors.productBasedOfferIdSelector)(state, requiredOnboardingMerchId);

    if (productBasedOfferId) {
      // Don't want to include the onboarding merch in both nonRecurringMerch and a product based offer
      return [];
    }

    var onboardingItemConfig = [(0, _itemConfigUtils2.createItemConfigObject)({
      merchandiseId: requiredOnboardingMerchId
    })];
    return onboardingItemConfig;
  };
};

exports.getCreateCheckoutOnboardingItemConfigSelector = getCreateCheckoutOnboardingItemConfigSelector;

var getCreateAdditionalUnitsItemConfigSelector = function getCreateAdditionalUnitsItemConfigSelector(state) {
  return function (merchId) {
    var additionalUnitQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var createIfEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
    var baseMerch;

    if (merchandiseMap[merchId].additionalUnitMerchId) {
      baseMerch = merchandiseMap[merchId];
    } else {
      baseMerch = (0, _MerchandiseSelectors2.baseMerchForAdditionalUnitSelector)(state, merchId);
    }

    if (!baseMerch) return [];
    var _baseMerch = baseMerch,
        additionalUnitMerchId = _baseMerch.additionalUnitMerchId,
        includedAdditionalUnits = _baseMerch.includedAdditionalUnits;
    if (!additionalUnitMerchId) return [];
    var unitQuantityToPurchase = additionalUnitQuantity; // Contacts-based merch should include the includedAdditionalUnits
    // bc the "included" contacts don't come with the base SKU by default.
    // This will change starting with the Marketing Contacts SKUs.
    // See thread: https://hubspot.slack.com/archives/CV5RT7CN8/p1588275759046600

    if (merchandiseMap[additionalUnitMerchId].units === 'contact') {
      unitQuantityToPurchase += includedAdditionalUnits;
    }

    if (!unitQuantityToPurchase && !createIfEmpty) return [];
    return [(0, _itemConfigUtils2.createItemConfigObject)({
      merchandiseId: additionalUnitMerchId,
      quantity: unitQuantityToPurchase
    })];
  };
};

exports.getCreateAdditionalUnitsItemConfigSelector = getCreateAdditionalUnitsItemConfigSelector;

var getCreateItemConfigWithAdditionalUnitsSelector = function getCreateItemConfigWithAdditionalUnitsSelector(state) {
  return function (merchId, additionalUnitQuantity) {
    var baseItemConfig = (0, _itemConfigUtils2.createItemConfigObject)({
      merchandiseId: merchId
    });
    var additionalUnitsItemConfig = getCreateAdditionalUnitsItemConfigSelector(state)(merchId, additionalUnitQuantity);
    return [baseItemConfig].concat((0, _toConsumableArray2.default)(additionalUnitsItemConfig));
  };
}; // Returns itemConfigs with base merch, additional units, and onboarding


var getCreateItemConfigWithMandatoryMerchSelector = function getCreateItemConfigWithMandatoryMerchSelector(state) {
  return function (merchId, additionalUnitQuantity) {
    var recurringMerchItemConfigs = getCreateItemConfigWithAdditionalUnitsSelector(state)(merchId, additionalUnitQuantity);
    var onboardingItemConfigs = getCreateCheckoutOnboardingItemConfigSelector(state)(merchId);
    return [].concat((0, _toConsumableArray2.default)(recurringMerchItemConfigs), (0, _toConsumableArray2.default)(onboardingItemConfigs));
  };
};
/**
 * The difference between this and getCreateItemConfigWithMandatoryMerchSelector is
 * this one won't include base merchandise if it's already owned, so this is
 * intended to be used when generating item configurations for sending to checkout
 */


exports.getCreateItemConfigWithMandatoryMerchSelector = getCreateItemConfigWithMandatoryMerchSelector;

var getCreateCheckoutItemConfigWithMandatoryMerchSelector = function getCreateCheckoutItemConfigWithMandatoryMerchSelector(state) {
  return function (merchandiseId, additionalUnitQuantity) {
    var ownsProduct = (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId);

    if (!ownsProduct) {
      return getCreateItemConfigWithMandatoryMerchSelector(state)(merchandiseId, additionalUnitQuantity);
    }

    return getCreateAdditionalUnitsItemConfigSelector(state)(merchandiseId, additionalUnitQuantity, true);
  };
};

exports.getCreateCheckoutItemConfigWithMandatoryMerchSelector = getCreateCheckoutItemConfigWithMandatoryMerchSelector;

var getCreateSuiteItemConfigsSelector = function getCreateSuiteItemConfigsSelector(state) {
  return function (edition) {
    var additionalUnitQuantities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var createItemConfigWithAdditionalUnits = getCreateItemConfigWithAdditionalUnitsSelector(state);
    var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
    var hubToMerchIdMap = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition];
    var itemConfigs = [];
    Object.keys(hubToMerchIdMap).forEach(function (hub) {
      var merchandiseId = hubToMerchIdMap[hub];
      var additionalUnitQuantity = additionalUnitQuantities[hub] || 0;
      itemConfigs = itemConfigs.concat(createItemConfigWithAdditionalUnits(merchandiseId, additionalUnitQuantity));
    });
    return itemConfigs;
  };
};

exports.getCreateSuiteItemConfigsSelector = getCreateSuiteItemConfigsSelector;

var getBundleItemConfigsSelector = function getBundleItemConfigsSelector(state) {
  return function (bundleSelections) {
    var createItemConfigWithMandatoryMerch = getCreateItemConfigWithMandatoryMerchSelector(state);
    var marketingPlanSelected = bundleSelections.marketingPlanSelected,
        salesPlanSelected = bundleSelections.salesPlanSelected,
        servicePlanSelected = bundleSelections.servicePlanSelected,
        cmsPlanSelected = bundleSelections.cmsPlanSelected,
        _bundleSelections$mar = bundleSelections.marketingUnits,
        marketingUnits = _bundleSelections$mar === void 0 ? 0 : _bundleSelections$mar,
        _bundleSelections$sal = bundleSelections.salesUnits,
        salesUnits = _bundleSelections$sal === void 0 ? 0 : _bundleSelections$sal,
        _bundleSelections$ser = bundleSelections.serviceUnits,
        serviceUnits = _bundleSelections$ser === void 0 ? 0 : _bundleSelections$ser,
        _bundleSelections$sel = bundleSelections.selectedAddOns,
        selectedAddOns = _bundleSelections$sel === void 0 ? [] : _bundleSelections$sel,
        _bundleSelections$sel2 = bundleSelections.selectedServices,
        selectedServices = _bundleSelections$sel2 === void 0 ? [] : _bundleSelections$sel2;
    var itemConfigs = [];

    var addItemConfig = function addItemConfig(merchandiseId) {
      var additionalUnitQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      itemConfigs.push.apply(itemConfigs, (0, _toConsumableArray2.default)(createItemConfigWithMandatoryMerch(merchandiseId, additionalUnitQuantity)));
    };

    if (marketingPlanSelected) {
      addItemConfig(marketingPlanSelected, marketingUnits);
    }

    if (salesPlanSelected) addItemConfig(salesPlanSelected, salesUnits);
    if (servicePlanSelected) addItemConfig(servicePlanSelected, serviceUnits);
    if (cmsPlanSelected) addItemConfig(cmsPlanSelected);
    selectedAddOns.forEach(function (merchId) {
      return addItemConfig(merchId);
    });
    selectedServices.forEach(function (merchId) {
      return addItemConfig(merchId);
    });
    return itemConfigs;
  };
};

exports.getBundleItemConfigsSelector = getBundleItemConfigsSelector;

var defaultItemConfigSelector = function defaultItemConfigSelector(state, merchId) {
  var isContactsBased = _MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId);

  var additionalUnitQuantity = isContactsBased ? (0, _ContactsSelectors.minPurchasableContactsSelector)(state, merchId) : 0;
  var itemConfig = getCreateItemConfigWithMandatoryMerchSelector(state)(merchId, additionalUnitQuantity);
  return itemConfig;
};

exports.defaultItemConfigSelector = defaultItemConfigSelector;

var getBaseMarketingMerchFromConfigsSelector = function getBaseMarketingMerchFromConfigsSelector(state) {
  return function (itemConfigurations) {
    if (!itemConfigurations) {
      return null;
    }

    var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
    var foundMarketingMerch = itemConfigurations.find(function (_ref) {
      var merchandiseId = _ref.merchandiseId;
      return _HubMap.default[_Hubs.default.HUB_MARKETING].merchandise.includes(merchandiseId);
    });
    if (!foundMarketingMerch) return null;
    var marketingRelatedMerch = merchandiseMap[foundMarketingMerch.merchandiseId];

    if (marketingRelatedMerch.additionalUnitMerchId) {
      return marketingRelatedMerch;
    }

    return (0, _MerchandiseSelectors2.baseMerchForAdditionalUnitSelector)(state, marketingRelatedMerch.id);
  };
};

exports.getBaseMarketingMerchFromConfigsSelector = getBaseMarketingMerchFromConfigsSelector;